const extractErrorMessage = (err: Error): string => {
  const cause = err.cause;

  if (typeof cause === 'string') {
    return cause;
  }

  if (cause && typeof cause === 'object' && 'message' in cause) {
    const maybeError = cause as { message?: unknown };
    if (typeof maybeError.message === 'string') {
      return maybeError.message;
    }
  }

  return err.message;
};

export const toError = (u: unknown): Error => (u instanceof Error ? u : new Error('Unknown error', { cause: u }));

// eslint-disable-next-line no-console
export const logError = (scope: string) => (err: Error) => console.debug(`[${scope}]:`, extractErrorMessage(err));

export const resetLoading = (loading: (boolean) => void) => () => {
  loading(false);
  return false;
};
